export const ALL_CUSTOMERS_MAINTENANCE_MODE_ID = 'allCustomers';
export const ALL_CUSTOMERS_LABEL = 'All Customers';

// setTimeout overflows past ~24.8 days, so re-check expiry at least hourly.
export const MAX_EXPIRY_CHECK_MS = 60 * 60 * 1000;
